module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAwCAYAAABjezibAAAAwklEQVRYhdWYwRHDMAgED5l800D6f6RDJ7aPpAK+rLeCnZNAiKjrXQKTOl7TDi2pB1zQ6znt0JLnOa3Qk1uwDXPpmnZoyTJdsDzt0JIOuGAJXiTlfdqhJaPgCS56keATDB3TDi03qOKivySmJ4i/g/5OO7T82ww8QRU8QdMFF74P+jPt0JLitxm6IH2aMV0w6FUs0f8k9ATxmwXRB1bT+6Dobabo82DQ94P4I75BgvA7iD9i/GYB/5KIvh9U0BNcbMEfUzlgyPaKQAgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/szrt_revision/teachingDetail/list/mockexamination/imgs/2.png
// module id = nOQ8
// module chunks = 96